import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox as MUICheckbox } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { get } from 'lodash';
import { cn } from '@src/utils/ui';

export const Checkbox = ({
    id,
    name,
    value,
    by,
    label,
    className,
    onChange,
    labelClassName = '',
    checkBoxProps = {}
}) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                const handleChange = e => {
                    if (onChange) onChange(e);
                    field.onChange(e.target.checked ? value : null);
                };

                return (
                    <label
                        htmlFor={id || name}
                        className={cn(
                            `tw-cursor-pointer tw-font-normal tw-inline-flex tw-items-center tw-ml-[-10px]`,
                            className
                        )}
                    >
                        <MUICheckbox
                            id={id || name}
                            size='large'
                            checked={by ? get(field.value, by) === get(value, by) : field.value === value}
                            onChange={handleChange}
                            inputRef={field.ref}
                            className={cn(
                                'tw-border-2 tw-border-primary-500 tw-text-primary-500 checked:tw-border-primary tw-mt-[-5px]',
                                checkBoxProps?.className
                            )}
                            {...checkBoxProps}
                        />
                        {typeof React.isValidElement(label) ? (
                            label
                        ) : (
                            <span className={cn(labelClassName)}>{label}</span>
                        )}
                    </label>
                );
            }}
        />
    );
};

// -------- PropTypes -------- //

Checkbox.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    by: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    className: PropTypes.string,
    labelClassName: PropTypes.string,
    checkBoxProps: PropTypes.object,
    onChange: PropTypes.func
};
